import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SerieForm, useSerie } from '@/features/series-management';
import { Skeleton } from '@/shared/ui/atoms';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute('/_authenticated/series/$serieId/')({
  component: SerieEditPage,
});

/** Página de edição de Série. */
export function SerieEditPage() {
  const { t } = useTranslation('series');
  const { serieId } = Route.useParams();
  const navigate = useNavigate();

  const { serie, isLoading } = useSerie(Number(serieId));

  const goBack = () => void navigate({ to: '/series' });

  return (
    <div className="flex flex-col gap-xxs">
      <PageHeader
        title={t('series.form.editTitle')}
        breadcrumb={
          <Breadcrumb>
            <BreadcrumbLink>
              <Link to="/">
                <BreadcrumbIcon />
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series">{t('series.breadcrumb.series')}</Link>
            </BreadcrumbLink>
            <BreadcrumbPage>{t('series.form.editTitle')}</BreadcrumbPage>
          </Breadcrumb>
        }
      />

      {isLoading ? (
        <Skeleton className="h-[480px] w-full rounded-sm" />
      ) : (
        <SerieForm serie={serie ?? null} onSaved={goBack} onCancel={goBack} />
      )}
    </div>
  );
}
